import React from 'react'

export const lazyWithPreload = importStatement => {
  const Component = React.lazy(importStatement)
  Component.preload = importStatement
  return Component
}
